var map = {
	"./VisualRecognition.svg": "2e5d",
	"./analytics.svg": "3fbe",
	"./arrow.svg": "773a",
	"./commodities.svg": "6bb0",
	"./configgrp.svg": "a0ea",
	"./configusr.svg": "fc3f",
	"./hamburger.svg": "559b",
	"./imageAnalysis.svg": "da3f",
	"./line.svg": "a2b7",
	"./logo.svg": "13fd",
	"./minilogo.svg": "cc53",
	"./search.svg": "15a3",
	"./summary.svg": "c7d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ea0";